import React, { useEffect } from 'react';
import Alert from '../Alert';
import { useMobile } from '../Mobile';
import { useOffline } from '../Offline';

const UninstalledUpdatePrompt = () => {
    const {downloadingUpdate, updateAvailable, installUpdate} = useMobile();
    const {isOnline} = useOffline();

    // Force an immediate install of the update if it's already available and we're online
    useEffect(() => {
        if (!updateAvailable || downloadingUpdate) {
            return;
        }

        if (!isOnline) {
            return;
        }

        installUpdate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!updateAvailable && !downloadingUpdate) {
        return null;
    }

    if (downloadingUpdate) {
        return (
            <Alert
                theme="brand"
                icon="PartyHorn"
                title="Updating..."
                message="Downloading the latest version of getSoapy, just a moment..."
                loading={true}
            />
        );
    }

    return (
        <Alert
            theme="brand"
            icon="PartyHorn"
            title="Update available"
            message="There's a new version of getSoapy available! Tap to update."
            onClick={installUpdate}
        />
    );

}

export default UninstalledUpdatePrompt;
